/** @returns Ids from a JSON array, or from text separated by commas, semicolons or whitespace. */
export function parseIdList(text: string): string[] {
    try {
        const parsed: unknown = JSON.parse(text);
        if (Array.isArray(parsed)) {
            return parsed.map(String);
        }
    } catch {
        // Not JSON; fall through to splitting.
    }
    return text
        .split(/[\s,;]+/)
        .map((token) => token.replace(/^["']|["']$/g, ""))
        .filter(Boolean);
}
